import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CoreLib } from '../../shared/models/core-lib';
import { Observable, throwError, ReplaySubject } from 'rxjs';
import { User, RoleTypes } from '../../shared/models/user';
import { catchError, tap, map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserType } from '../../shared/models/user-type';
import { Token } from '@angular/compiler';
import { JQueryStatic } from '../../_helpers/jquery';
import { AuthState, UserState } from '../reducers/shell.reducer';

declare var core: CoreLib;
declare var baseUrl: string;
declare var baseApiUrl: string;

declare var $: JQueryStatic;

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  
  constructor(private http: HttpClient) {}

  loggedIn(): Observable<boolean> {
    var requestUrl = `${baseApiUrl}/loggedIn`;

    return this.http.get<boolean>(requestUrl)
      .pipe(map((response: any) => {
        if (response.success)
          return true;
        else
          return false;
      })
      );
  }

  private createUserStateFromToken(token: string): AuthState {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token);
    const roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || [];
    let userType: UserType;

    if (roles.indexOf(RoleTypes.adminRole) > -1) {
      userType = UserType.Administrative;
    }
    else {
      userType = UserType.Guest;
    }

    const payload: AuthState = {
      authenticated: true,
      token: decodedToken,
      user: {
        email: decodedToken['Email'],
        fullName: decodedToken['FullName'],
        useName: decodedToken["UserName"],
        userId: decodedToken["UserId"],
        userType: userType,
        lastLogin: decodedToken["LastLogin"],
        isAdmin: roles && roles.indexOf(RoleTypes.adminRole) > -1,
        roles: roles instanceof Array ? roles : [roles]
      },
      sessionExtended: false
    };
    return payload;
  }

  getUserFromToken(): Observable<AuthState> {
    const requestUrl = `${baseUrl}/account/gettoken`;

    console.log("Account service getToken called");

    return this.http.get<any>(requestUrl)
      .pipe(
        map((token: any) => {
          return this.createUserStateFromToken(token.token);
        }),
        catchError((httpError: HttpErrorResponse) => this.handleError(httpError))
      );
  }

  getModalLoginForm(): Observable<string> {
    let requestUrl = `${baseUrl}account/login?showModal=true`;
    const getOptions = { responseType: 'text' as 'text'};
    return this.http.get(requestUrl, getOptions)
    .pipe(
      map((resp: string) => {
        return resp;
      })
    );
  }

  login(username: string, password: string): Observable<boolean> {
    var requestUrl = `${baseUrl}/account/LoginAsync?showmodal=true`;
    var params = { UserName: username, Password: password, apiLogin: '1' };

    return this.http.post<any>(requestUrl, params)
      .pipe(
        map((token: any) => {
          return true;
        }),
        catchError((httpError: HttpErrorResponse) => this.handleError(httpError))
      );
  }

  handleError(httpError: HttpErrorResponse): Observable<never> {
    var errorMessage = "An unknown error occurred while submitting the request";

    if (httpError.error && httpError.error.message) {
      errorMessage = httpError.error.message;
    }

    //core.pageBanner.loadResponse(errorMessage, { title: "Error occurred", type: core.pageBanner.bannerTypes.error });

    return throwError(httpError);

  }
}
